import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=370145a1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src214510003/src/oldmillvillagerentals/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370145a1"]])

export default __exports__